import { Injectable } from '@angular/core';

import {environment} from '@app/environment';

@Injectable({
    providedIn: 'root'
})
export class CookiesService {

    constructor() { }
    
    set(cname: string, cvalue: string, exdays: number) {
        cname = this.checkCname(cname);
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires="+d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + "; domain="+environment.COOKIE_DOMAIN+"; path=/";
    }
    
    get(cname: string): string {
        cname = this.checkCname(cname);
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
    
    delete(cname: string){
        cname = this.checkCname(cname);
        document.cookie = cname + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain="+environment.COOKIE_DOMAIN+"; path=/;";
    }
    
    checkCname(cname: string){
        let regex = new RegExp('^'+environment.PREFIX_LOCALSTORAGE+'_');        
        if(!regex.test(cname)){
            cname = environment.PREFIX_LOCALSTORAGE+'_'+cname;
        }      
        return cname;
    }
}
